module.exports = __webpack_public_path__ + "static/media/icon_overenezakaznikmi.0319d906.png";